import {ItemQuantity} from '../models/warehouse-models';
import {manualAmountMl} from './manual-handout-allocation';

export interface ManualOperation {
    targetDifferences?: {passportId?: number; name: string; target: number; selected: number; targetMl?: number; selectedMl?: number}[];
    operatorId: number;
    recipientName: string;
    warehouseName: string;
    request: {
        operationId: string;
        forUserId: number;
        warehouseId: number;
        items: {id: number; passportId: number; warehouseId: number; batchCode: string; count: number; reservationId?: number}[];
    };
    lines: {id: number; name: string; batchCode: string; count: number; amountMl?: number}[];
}

export const selectedManualItems = (items: ItemQuantity[]) => items.filter(item => item.id && (item.selectedCount ?? 0) > 0);
export const createManualOperationId = () => {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export const newManualOperation = (operatorId: number, recipient: {id: number; username: string},
    warehouseId: number, warehouseName: string, quantities: ItemQuantity[],
    operationId = createManualOperationId(), reservations: Record<number, ManualReservation> = {}): ManualOperation => {
    const items = selectedManualItems(quantities);
    return {
        operatorId, recipientName: recipient.username, warehouseName,
        request: {operationId, forUserId: recipient.id, warehouseId,
            items: items.map(item => ({id: item.id!, passportId: item.passport.passportId!, warehouseId,
                batchCode: item.batchCode, count: item.selectedCount!, reservationId: reservations[item.id!]?.reservationId}))},
        lines: items.map(item => ({id: item.id!, name: item.passport.passport, batchCode: item.batchCode,
            count: item.selectedCount!, amountMl: manualAmountMl(item, item.selectedCount!)}))
    };
};
const prefix = 'aroma.manual-handout.pending.';
export const savePendingManualOperation = (operation: ManualOperation) =>
    localStorage.setItem(prefix + operation.request.operationId, JSON.stringify(operation));
export const removePendingManualOperation = (operation: ManualOperation) =>
    localStorage.removeItem(prefix + operation.request.operationId);
export const pendingManualOperations = (operatorId: number | undefined, warehouseId: number): ManualOperation[] => {
    const operations: ManualOperation[] = [];
    for (let index = 0; index < localStorage.length; index++) {
        const key = localStorage.key(index);
        if (!key?.startsWith(prefix)) continue;
        try {
            const operation = JSON.parse(localStorage.getItem(key)!);
            if (operatorId != null && operation.operatorId === operatorId && operation.request.warehouseId === warehouseId) operations.push(operation);
        } catch { /* Unrelated or invalid storage entries never become a selection. */ }
    }
    return operations;
};


export interface ManualReservation {
    reservationId: number;
    quantityId: number;
    reservedCount: number;
    forUserId: number;
    expiresAt: string;
}
export interface ManualReservationRequest {
    operationId: string;
    forUserId: number;
    warehouseId: number;
    revision: number;
    items: ManualOperation['request']['items'];
}
export interface ManualReservationSnapshot {
    revision: number;
    reservations: ManualReservation[];
}
